/* eslint-disable react/forbid-prop-types */
/* eslint-disable react/require-default-props */
import React, { Component } from 'react';
import { ComboBox, DropdownSkeleton } from 'carbon-components-react';
import PropTypes from 'prop-types';

export default class EmployerComboBox extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      items: [],
      allItems:
        this.props.itemsToExclude?.length > 0
          ? this.props.items.filter((item) => {
              const deletedId = this.props.itemsToExclude.map((filter) => filter.id);
              const itemId = item.id;
              return !deletedId.includes(itemId);
            })
          : this.props.items
    };
    this.onChange = this.onChange.bind(this);
  }

  onChange = (selectedItem) => {
    const item = selectedItem ? selectedItem.selectedItem : null;
    this.props.onChange(item);
  };

  onFilter = (inputValue) => {
    if (!inputValue || inputValue.length < 3) {
      this.setState({
        items: []
      });
    } else {
      this.setState((prevState) => {
        let items = { ...prevState.items };
        items = prevState.allItems.filter((item) =>
          item.fullname.toLowerCase().includes(inputValue.toLowerCase())
        );
        return { items };
      });
    }
  };

  render() {
    return this.state.loading ? (
      <DropdownSkeleton />
    ) : (
      <ComboBox
        id="comboBoxEmployer"
        // disabled={this.state.items < 1}
        placeholder="Start typing to choose an Employer"
        items={this.state.items}
        onChange={this.onChange}
        onInputChange={this.onFilter}
        itemToString={(item) => (item ? item && `${item.fullname}` : '')}
        selectedItem={this.props.selectedItem}
      />
    );
  }
}

EmployerComboBox.propTypes = {
  onChange: PropTypes.func.isRequired,
  selectedItem: PropTypes.object,
  items: PropTypes.array.isRequired,
  itemsToExclude: PropTypes.array
};
EmployerComboBox.defaultProps = {
  selectedItem: null,
  itemsToExclude: null
};
